import { render, staticRenderFns } from "./ExpedientGlobalVisionTopBarComponent.vue?vue&type=template&id=f0c05f94&scoped=true"
import script from "./ExpedientGlobalVisionTopBarComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpedientGlobalVisionTopBarComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ExpedientGlobalVisionTopBarComponent.vue?vue&type=style&index=0&id=f0c05f94&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c05f94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0c05f94')) {
      api.createRecord('f0c05f94', component.options)
    } else {
      api.reload('f0c05f94', component.options)
    }
    module.hot.accept("./ExpedientGlobalVisionTopBarComponent.vue?vue&type=template&id=f0c05f94&scoped=true", function () {
      api.rerender('f0c05f94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/expedients/ExpedientGlobalVision/ExpedientGlobalVisionTopBarComponent.vue"
export default component.exports